var angular = require('angular');
var _module = angular.module('benoit');

require('./_styles.scss');
require('../../services/lr-touch');
require('../../services/share-modal');
require('../../services/fullscreen-loading');

var shareBtnCtrlErr = angular.$$minErr('ShareBtnCtrl');

_module.controller('ShareBtnCtrl', [
    '$log',
    '$http',
    '$location',
    '$shareModal',
    '$fsloading',

    function ShareBtnCtrl($log, $http, $location, $shareModal, $fsloading) {
        $log.debug('ShareBtnCtrl', this);

        var vm = this;
        vm.model = {};
        vm.events = {
            onClick: openShareModal
        };

        // Functions
        function openShareModal() {
            var port = ':' + $location.port();
            var url = $location.protocol() + '://' + $location.host();
            if(port !== ':' && port !== ':80' && port !== ':443') url += port;
            url += $location.path();

            var qParams = [];
            if($location.search().affiliate) qParams.push('affiliate=' + $location.search().affiliate);
            if($location.search().filter) qParams.push('filter=' + $location.search().filter);
            if(qParams.length) url += '?' + qParams.join('&');

            $fsloading.show();

            $http.post('/v1/shorten-url', { url: url })
            .then(function (response) {
                return response.data.data;
            })
            .catch(function (err) {
                shareBtnCtrlErr(err);
                return url;
            })
            .then(function (shareUrl) {
                $shareModal(encodeURIComponent(shareUrl), vm.listing, vm.searchFilterId, { facebookUrl: encodeURIComponent(url) });
            })
            .finally($fsloading.hide.bind($fsloading));
        }
    }
]);

_module.component('shareBtn', {
    controller: 'ShareBtnCtrl',
    controllerAs: 'vm',
    template: require('./index.html'),
    bindings: {
        listing: '<',
        searchFilterId: '@'
    }
});
